module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201112_040.dd5726a0.jpg";